import React, { Component } from 'react'
import { Button, Form, Table, Input, Row, Col, DatePicker, Drawer, Icon, Modal } from 'antd'
import moment from 'moment'

import { getReturnDetailStatus, getTouristes, stopGroupDate } from '_src/api/api'


import TravellerList from './travellerList'
import TouristOrders from './touristOrders'


import '_src/common/style/common.less' 


const { RangePicker } = DatePicker
const { Search } = Input
const { confirm } = Modal
@Form.create({ name: '' })
class Tourister extends Component {
  constructor (props) {
    super(props)
    // 参数集合
    this.param = {
      travelName: '', // 服务单号
      contacts: '', // 收货人
      // createAt: '', // 申请时间
      pageNum: 0,
      createStart: '',
      createEnd: '',
      totalElements: 0
    }
    this.state = {
      itemStatus: '',
      status: '',
      loading: true,
      visible: false,
      dataList: [],
      statusBtns: [],
      record: {},
      opentType: null // 抽屉打开状态 1 -> 查看人数，2专线订单列表
    }
  }

  componentDidMount () {
    this.loadData()
    getReturnDetailStatus()
      .then(res=>{
        const { data } = res
        const arr = data.map(item=>{
          item.status = item.status === '总数'? '' : item.status
          return { num: item.count, id: item.status}
        })
        this.setState({
          statusBtns: arr
        })
      })
  }
  loadData () {
    this.setState({loading: true})
    const { pageNum, travelName, createAt, createStart, createEnd } = this.param
    const { status } = this.state
    let param = {pageNum, status, pageSize: 10}
    if (!!travelName) {
      param = {...param, travelName}
    }
    if (!!createAt) {
      param = {...param, createAt}
    }
    if (!!createStart&&!!createEnd) {
      param = {...param, createStart, createEnd}
    }
    // 获取列表信息
    getTouristes(param)
      .then(res=>{
        const { data } = res
        this.param.totalElements = data.totalElements
        const dataList = data.content.map(item=>{
          return {...item, key: item.travelId, id: item.travelId}
        })
        this.setState({
          dataList: dataList,
          loading: false,
          visible: false
        })
      })
  }
  
  columns = () => {
    return [
      {
        title: <span>旅游线路名称</span>,
        align: 'center',
        dataIndex: 'travelName',
        key: 'travelName',
      },
      {
        title: <span>日期</span>,
        align: 'center',
        dataIndex: 'groupDate',
        key: 'groupDate',
      },
      {
        title: <span>参团人数</span>,
        align: 'center',
        dataIndex: 'passengers',
        
      },     
      {
        title: <span>订单总金额</span>,
        align: 'center',
        dataIndex: 'totalAmount',
      },
      {
        title: <span>退款金额</span>,
        align: 'center',
        dataIndex: 'refundAmount',
      },
      {
        title: <span>应收总金额</span>,
        align: 'center',
        dataIndex: 'receivableAmount',
      },
      {
        title: <span>操作</span>,
        align: 'center',
        dataIndex: 'opt',
        width: 300,
        className: 'opt_colum',
        render: (_, record) => 
          (<div className = "table_btn">
            <Button type = "link" icon="eye" style={{marginRight: '10px'}} onClick = { () => { this.openDrawer(record, 1) } } >查看报名</Button>
            <Button type = "link" icon="stop" style={{marginRight: '10px', color: 'red'}} onClick = { () => { this.handleStopGroupDate(record) } } >停止参团</Button>
            <Button type = "link" icon="usergroup-delete" style={{marginRight: '10px'}} onClick = { () => { this.openDrawer(record, 2) } } >线路订单</Button>
          </div>),
      },
    ]
  }

  // 关闭抽屉
  onClose = () => {
    this.setState({
      visible: false
    })
  }

  // 打开抽屉
  openDrawer = (record, type) => {
    this.setState(()=>({
      visible: true,
      record,
      itemStatus: record.status,
      opentType: type
    }))
  }
  // 搜索
  handleSearch = (key, value) => {
    this.param[key] = value
    this.param.pageNum = 0
    this.loadData()
  }
  // 时间搜索
  handleDateSearch = (key, _, dateString) => {
    this.param[key] = dateString
    this.param.pageNum = 0
    this.loadData()
  }
  timerChange = (e) => {
    this.param.pageNum = 0
    this.param.createStart = moment(e[0]).format('YYYY-MM-DD')
    this.param.createEnd = moment(e[1]).format('YYYY-MM-DD')
    this.loadData()
  }
  // 状态按钮搜索
  handleBtnSearch = (status) => {
    this.setState({
      status
    }, ()=>{
      this.param.pageNum = 0
     
      this.loadData()
    })
  }

  // 停止参团
  handleStopGroupDate = (record) => {
    const { travelName, groupDate, travelId } = record
    const _sefl = this
    confirm({
      title: '温馨提示',
      content: (
        <p>你确定要将停止
          <strong style = {{color: '#000'}}> {travelName}</strong> 吗？
        </p>),
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk () {
        stopGroupDate({groupDate, travelId})
        _sefl.loadData()
      },
      onCancel () {
      },
    })
  }
  pangeChange = (page) => {
    this.param.pageNum = (page - 1)
    this.loadData()
  }
  render () {
    const { dataList, loading, visible, record, opentType } = this.state
    const { pageNum, totalElements } = this.param
    // const statusBtns = [
    //   {text: '全部申请', num: this.totalElements},
    //   {text: '待处理', num: this.totalElements},
    //   {text: '退货中', num: this.totalElements},
    //   {text: '已完成', num: this.totalElements},
    //   {text: '已拒绝', num: this.totalElements},
    // ]
    const drawerHeader = (
      <div className = "page_top">
        <p className = "page_top_title">
          旅游线路-<span style = {{color: 'red'}} >{record.travelName}</span>
        </p>
        <div className = "returnDetail_btn">
          <Button className = "" type="primary" onClick = {this.onClose}>
            <Icon type="left" />
            返回
          </Button>
        </div>
      </div>
    )

    // 抽屉内容
    let drawerContent = null
    if (opentType === 1) {
      drawerContent = <TravellerList record = {record} />
    }
    if (opentType === 2) {
      drawerContent = <TouristOrders record = {record} />
    }


    return (
      <div className = "ReturnForm page_content" >
      
        
        <Form className = "goodlist_from">
          <div style = {{maxWidth: 900}}>
            <Row gutter = {24}>
              <Col span = {8}>
                <Form.Item label = "线路名称" >
                  <Search placeholder="请输入线路名称" onSearch={(v)=>{ this.handleSearch('travelName', v) }} enterButton />
                </Form.Item>
              </Col>
              <Col span = {8}>
                <Form.Item label = "申请时间">
                  <RangePicker style={{ width: 220 }} onChange={this.timerChange} />
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Form>
        <Table
          loading = {loading} 
          bordered
  
          columns = {this.columns()} 
          dataSource = {dataList}
          pagination = {{ 
            current: (pageNum + 1),
            total: totalElements,
            onChange: (page) => { this.pangeChange(page) }
          }}
        />
        <Drawer
          title={drawerHeader}
          width={'900'}
          onClose={this.onClose}
          destroyOnClose
          closable = {false}
          visible = {visible}
        >
          {drawerContent}
        </Drawer>
        
      </div>
    )
  }
}


// const SearchButton = (props) => {
//   function handleClick (id) {
//     const { handleSearch } = props   
//     // const { handleSearch } = this.props
//     handleSearch && handleSearch(id)
//   }
//   const { label, state, id} = props
//   const { text, num } = label|| {}
//   return (
//     <Button className = {`filterBtn ${state === id?'act':''}`} onClick = {()=>{ handleClick(id) }}>
//       {text}<span className = "num">{num&&`（${num}）`}</span>
//     </Button>
//   )
// }

export default Tourister